<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-header w-100 p-2 mb-0">
        <div class="col-xl-3 col-12 pl-0">
          <input type="search" [placeholder]="'SEARCH' | translate" class="form-control" (change)="filterRefunds()" [(ngModel)]="searchKeyword" />
        </div>
        <div class="col-xl-3 col-12" [ngClass.sm]="'mt-1'">
          <select [(ngModel)]="searchStatus" class="form-control" (change)="filterRefunds()">
            <option value="10" selected>{{ "ALL_STATUSES" | translate }}</option>
            <option value="0">{{ "PENDING" | translate }}</option>
            <option value="1">{{ "APPROVED_FEMALE_PLURAL" | translate }}</option>
            <option value="2">{{ "NOT_APPROVED_PLURAL" | translate }}</option>
          </select>
        </div>
        <div class="col-xl-6 col-12 text-right pr-0">
          <div class="w-fit d-inline-block mr-2" *ngIf="_utilService.isDesktop">
            <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
          </div>
          <button type="button" class="btn btn-outline-primary" (click)="showModalAdd = true">{{'REQUIRE_REFUND' | translate}}</button>
        </div>
      </div>
      <div class="card-body p-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 50 : 150"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [limit]="tableLimit"
          [footerHeight]="50"
          [rows]="refundsFiltered"
        >
          <ngx-datatable-column name="{{ 'AMOUNT' | translate }}" prop="amount" width="200" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.amount | currency:'EUR' }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'DAY_CAPITALIZE' | translate }}" prop="date" width="100" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.date | date: "dd/MM/yyyy" }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'STATE' | translate }}" prop="status" width="100" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="badge" [ngClass]="{
              'badge-success': row.status === 1,
              'badge-warning': row.status === 0,
              'badge-danger': row.status === 2
              }">{{ row.enabled_label }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <button class="btn btn-outline-secondary btn-sm" (click)="openModal(viewRefunds, row)">{{ "VIEW" | translate }}</button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!-- mobile - tablet-->
          <ngx-datatable-column name="{{ 'AMOUNT' | translate }}" prop="date" sortable="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-12">
                  <div class="d-flex justify-content-between align-items-center mb-1" ngClass.md="pr-1">
                    <div>{{ row.amount }} €</div>
                    <span class="badge badge-success" *ngIf="row.status === 1">{{ row.enabled_label }}</span>
                    <span class="badge badge-warning" *ngIf="row.status === 0">{{ row.enabled_label }}</span>
                    <span class="badge badge-danger" *ngIf="row.status === 2">{{ row.enabled_label }}</span>
                  </div>
                  <div class="d-flex justify-content-between" ngClass.md="pr-1">
                    <span>{{ _utilService.formatDate(row.date, "DD/MM/YYYY") }}</span>
                    <button class="btn btn-outline-secondary btn-sm" (click)="openModal(viewRefunds, row)">{{ "VIEW" | translate }}</button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<ng-template #viewRefunds let-modal>
  <form>
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "REFUND" | translate }}</h3>
      <div class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "FIRSTNAME" | translate }}:</small>
          <p>{{ currentRefunds.employee.complete_name }}</p>
        </div>
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "AMOUNT" | translate }}:</small>
          <p>{{ currentRefunds.amount }} €</p>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "DAY_CAPITALIZE" | translate }}:</small>
          <p>{{ _utilService.formatDate(currentRefunds.date, "DD/MM/YYYY") }}</p>
        </div>
      </div>
      <div *ngIf="currentRefunds.note" class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "NOTE" | translate }}:</small>
          <p>{{ currentRefunds.note }}</p>
        </div>
      </div>
      <div *ngIf="currentRefunds.file_url" class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "FILE" | translate }}:</small>
          <a class="d-block text-primary" (click)="openFile(currentRefunds.file_url)">{{ "VIEW" | translate }} {{ "FILE" | translate }}</a>
        </div>
      </div>
      <div *ngIf="currentRefunds.status_note" class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "MOTIVATION" | translate }}:</small>
          <p>{{ currentRefunds.status_note }}</p>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button (click)="modal.close()" type="button" class="btn btn-primary">{{ "ALERT.BTN_CLOSE" | translate }}</button>
    </div>
  </form>
</ng-template>
<!-- / Modal -->
<app-request-refund-modal *ngIf="showModalAdd" (onClose)="loadRefunds(); showModalAdd = false;"></app-request-refund-modal>